<template>
    <div>
        <v-server-table ref="hseTypeTable" url="/admin/specific-body-parts-list" :columns="columns" :options="options">

            <router-link slot="SpecificBodyPartId" slot-scope="props" :to="`/incidents/settigns/specific-body-parts/edit/${props.row.SpecificBodyPartId}`" title="Edit Specific Body Part" class="btn btn-xs btn-secondary">
                Edit
            </router-link>

            <template slot="IsActive" slot-scope="props">
                <label :class="`text-${props.row.IsActive == 1 ? 'success' : 'danger'}`">
                    {{ props.row.IsActive == 1 ? 'Active' : 'Inactive' }}
                </label>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['SpecificBodyPartId', 'BodyPartName', 'MajorBodyPartName', 'IsActive'],
                options: {
                    headings: {
                        SpecificBodyPartId: 'Edit',
                        BodyPartName: 'Specific Body Part',
                        MajorBodyPartName: 'Major Body Part',
                        IsActive: 'Status'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'specificbodypart.BodyPartName',
                    },
                    uniqueKey: 'SpecificBodyPartId',
                },
            }
        }
    }
</script>
